import { API_CONFIG } from '../config/api';

export const getPublicBaseUrl = () => (API_CONFIG.BASE_URL || '').replace(/\/api\/?$/, '');

export const buildPublicFileUrl = (relativePath) => {
  const normalizedPath = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  return `${getPublicBaseUrl()}${normalizedPath}`;
};

export const downloadPublicFile = async (relativePath, fileName) => {
  const url = `${buildPublicFileUrl(relativePath)}?t=${Date.now()}`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to download file (${response.status})`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
};
